import { Injectable } from "@angular/core";
import { Log, LoggingFactory } from "@obg/ngx.global.evo";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { CoreHttpClient } from "../../http-client/http-client.service";
import { AUTH_MESSAGE_CODES } from "../auth.const";
import { SessionConfigService } from "../session.config";

import { ConvertSessionTokenResponse } from "./session-cookie.model";

@Injectable({
	providedIn: "root",
})
export class SessionCookieService {
	private logger: Log;

	constructor(
		private config: SessionConfigService,
		private httpClient: CoreHttpClient,
		loggingFactory: LoggingFactory
	) {
		this.logger = loggingFactory.get("sessionCookieService");
	}

	getSessionToken(): Observable<ConvertSessionTokenResponse | undefined> {
		this.logger.debug("getSessionToken::attempting to retrieve a converted sitecore cookie");
		return this.httpClient
			.get<ConvertSessionTokenResponse>({
				url: this.config.getSingleSignOnSessionTokenEndpoint(),
			})
			.pipe(
				map((response) => {
					if (!response.sessionToken) {
						this.logger.error("getSessionToken::session is empty, token could not be retrieved");
						return undefined;
					}

					this.logger.debug("getSessionToken::session token retrieved successfully");
					return response;
				}),
				catchError((error) => {
					if (error.code !== AUTH_MESSAGE_CODES.singleSignOn.siteCoreCookieNotInHeader) {
						this.logger.error(
							"getSessionToken::session token could not be retrieved due to an exception",
							JSON.stringify(error)
						);
					}

					return of(undefined);
				})
			);
	}
}
